// import { styled } from "styled-components";


import styled from "styled-components";
import { TextField } from "@mui/material";

export const InputSection = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 10px;
    gap:15px;
    
    align-items: center;
    
`;



/** (NOVO) Grid de inputs alinhado (3 colunas) e responsivo */
export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;



/** TextField com borda vermelha quando $invalid = true (sem mensagens) */
export const InputText = styled(TextField)<{ $invalid?: boolean }>`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
    border-width: ${({ $invalid }) => ($invalid ? "2px" : undefined)};
  }
  & .MuiInputLabel-root.Mui-error { color: inherit; }
`;
